var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4807 13.6231H1.40672C0.631032 13.6231 0 12.9921 0 12.2164V2.2036C0 1.78091 0.189419 1.3826 0.519492 1.11112C0.770959 0.907688 1.0852 0.796875 1.40672 0.796875H16.4807C16.7999 0.796875 17.1127 0.907688 17.3618 1.10893C17.6947 1.3735 17.8873 1.77326 17.8873 2.2036V12.2164C17.8873 12.9921 17.2562 13.6231 16.4807 13.6231ZM1.40672 1.54218C1.25297 1.54218 1.10904 1.59276 0.990583 1.68865C0.835554 1.81603 0.745302 2.00453 0.745302 2.2036V12.2164C0.745302 12.5811 1.04208 12.8778 1.40672 12.8778H16.4807C16.8454 12.8778 17.142 12.5811 17.142 12.2164V2.2036C17.142 2.00199 17.0523 1.81493 16.8956 1.69066C16.7764 1.59422 16.6299 1.54218 16.4807 1.54218H1.40672Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.94105 9.95628C8.84571 9.95628 8.75036 9.91989 8.67758 9.84711L0.491988 1.66152C0.346421 1.51595 0.346421 1.28013 0.491988 1.13457C0.637555 0.988999 0.873373 0.988999 1.01894 1.13457L8.94105 9.05668L16.8632 1.13457C17.0087 0.988999 17.2446 0.988999 17.3901 1.13457C17.5357 1.28013 17.5357 1.51595 17.3901 1.66152L9.20453 9.84711C9.13175 9.91989 9.0364 9.95628 8.94105 9.95628Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.a8a3f905ae7d526727237de6f7296ecd.svg";
export { ForwardRef as ReactComponent };